function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Stage } from '@inlet/react-pixi';
import * as R from 'unitx/ramda';
import React from 'react';
import { wrapComponent, useLayout, useForwardRef, ThemeProvider, useTheme } from 'unitx-ui';
import * as C from 'unitx/color';
import { View } from 'react-native';
import { useGraph } from "../../hooks";
import DataRender from 'unitx-ui/components/DataRender';
import "../../utils/addFlexLayout";
import Viewport from "../Viewport";
import NodeContainer from "../NodeContainer";
import EdgeContainer from "../EdgeContainer";
import ViewPIXI from "../View";
import Text from "../Text";
export const DefaultRenderNode = ({
  item
}) => /*#__PURE__*/React.createElement(ViewPIXI, {
  style: {
    width: 100,
    height: 100,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex'
  }
}, /*#__PURE__*/React.createElement(Text, null, item.id)); // @ts-ignore

export const DefaultRenderEdge = () => null; // <ViewPIXI style={{ width: 100, height: 100, backgroundColor: 'blue' }} />

function Graph(props, ref) {
  const {
    style,
    nodes = [],
    edges = [],
    onPress,
    renderNode = DefaultRenderNode,
    renderEdge = DefaultRenderEdge,
    drawLine,
    extraData,
    config = {}
  } = props;
  const graphID = React.useMemo(R.uuid, []);
  const stageRef = React.useRef(null);
  const viewportRef = React.useRef(null);
  const containerRef = React.useRef(null);
  const {
    cy
  } = useGraph({
    id: graphID,
    onLoad: () => {}
  });
  const graphRef = useForwardRef(ref, {
    cy
  });
  const {
    onLayout,
    width,
    height,
    initialized
  } = useLayout();
  const graphLayoutRef = React.useRef(null);
  React.useEffect(() => {
    var _stageRef$current;

    graphRef.current.app = (_stageRef$current = stageRef.current) === null || _stageRef$current === void 0 ? void 0 : _stageRef$current.app;
    graphRef.current.viewport = viewportRef.current;
  }, [initialized]);
  React.useEffect(() => {
    R.when(() => initialized && config.layout, () => {
      var _graphLayoutRef$curre;

      // @ts-ignore
      const {
        hitArea
      } = viewportRef.current;
      const boundingBox = {
        x1: hitArea.x,
        y1: hitArea.y,
        w: hitArea.width,
        h: hitArea.height
      };
      (_graphLayoutRef$curre = graphLayoutRef.current) === null || _graphLayoutRef$curre === void 0 ? void 0 : _graphLayoutRef$curre.stop(); // @ts-ignore

      graphLayoutRef.current = cy.createLayout(_objectSpread(_objectSpread({}, config.layout), {}, {
        boundingBox
      }));
      graphLayoutRef.current.on('layoutstop', () => {
        // @ts-ignore
        graphLayoutRef.current = null; // Fix the edge lines

        cy.edges().forEach(edge => {
          edge.data().onPositionChange();
        });
      });
      graphLayoutRef.current.start();
    })('');
  }, [initialized, config.layout]);
  const theme = useTheme();
  const backgroundColor = React.useMemo(() => C.rgbNumber(theme.colors.background), [theme.colors.background]);
  React.useEffect(() => {
    stageRef.current.app.renderer.backgroundColor = backgroundColor;
  }, [backgroundColor]);
  return /*#__PURE__*/React.createElement(View, {
    ref: containerRef,
    style: style,
    onLayout: onLayout
  }, /*#__PURE__*/React.createElement(Stage // @ts-ignore
  , _extends({
    ref: stageRef
  }, {
    width,
    height
  }, {
    options: {
      width,
      height,
      resolution: 1,
      antialias: true,
      autoDensity: true,
      backgroundColor
    }
  }), /*#__PURE__*/React.createElement(ThemeProvider // @ts-ignore
  , {
    theme: theme
  }, /*#__PURE__*/React.createElement(Viewport // @ts-ignore
  , _extends({
    ref: viewportRef,
    onPress: onPress,
    zoom: config.zoom,
    transform: config.transform
  }, {
    width,
    height
  }), /*#__PURE__*/React.createElement(DataRender, {
    extraData: [extraData, config.nodes],
    data: nodes,
    accessor: ['children'],
    keyExtractor: item => item.id,
    renderItem: ({
      item
    }) => {
      var _config$nodes;

      return /*#__PURE__*/React.createElement(NodeContainer, {
        graphID: graphID,
        item: item,
        config: (_config$nodes = config.nodes) === null || _config$nodes === void 0 ? void 0 : _config$nodes[item.id]
      }, renderNode);
    }
  }), /*#__PURE__*/React.createElement(DataRender, {
    extraData: [extraData, config.edges],
    data: edges,
    accessor: ['children'],
    keyExtractor: item => item.id,
    renderItem: ({
      item
    }) => {
      var _config$edges;

      return /*#__PURE__*/React.createElement(EdgeContainer, {
        graphID: graphID,
        item: item,
        drawLine: drawLine,
        config: (_config$edges = config.edges) === null || _config$edges === void 0 ? void 0 : _config$edges[item.id]
      }, renderEdge);
    }
  })))));
}
/**
 * ## Usage
 * To create a Graph View easily, you can just pass data and render methods.
 * Check example
 *
 * ```js live=true
 * function MyGraph() {
 *  const [data, setData] = React.useState({
 *    nodes: [
 *         { id: 1, position: { x: 10, y: 10 } },
 *         { id: 2, position: { x: 300, y: 100 } },
 *       ],
 *    edges: [
 *         { id: 51, source: 1, target: 2 }
 *       ]
 *  })
 *  return (
 *    <Graph
 *       style={{ width: '100%', height: 250 }}
 *       onPress={({ position }) => {
 *        setData({
 *          nodes: [
 *            ...data.nodes,
 *            { id: ''+(Math.random() * 1000).toFixed(0), position}
 *          ],
 *          edges: data.edges
 *        })
 *       }}
 *       nodes={data.nodes}
 *       edges={data.edges}
 *     />
 *  )
 * }
 * ```
 */


export default wrapComponent(Graph, {
  isForwardRef: true,
  isEqual: R.equalsExclude(R.isFunction)
});